import React, { useState } from 'react';
import type { FC } from 'react';

import { BinIcon } from './bin-icon';
import { BrokenThumbnailIcon } from './broken-thumbnail-icon';
import { BASE_Z_INDEX } from './z-index';

interface ListTileProps {
    index: number;
    title: string;
    thumbnail: string;
    size: string;
    isActive?: boolean;
    onClick?: () => void;
    onDelete?: () => void;
}

export const ListTile: FC<ListTileProps> = ({
    index,
    title,
    thumbnail,
    size,
    onClick,
    isActive,
    onDelete,
}) => {
    const [thumbnailLoadFailed, setThumbnailLoadFailed] = useState(false);

    return (
        <div className="flex flex-col gap-2 relative group">
            <div
                className={`w-full h-[175px] flex items-center justify-center chess-sm transition-opacity ${isActive ? 'bg-gray-100' : 'bg-black-50 hover:opacity-80 cursor-pointer'} rounded p-2 relative`}
                onClick={onClick}
                onKeyUp={(e) => e.key === 'Enter' && onClick?.()}
            >
                {onDelete && (
                    <button
                        type="button"
                        onClick={onDelete}
                        style={{ zIndex: BASE_Z_INDEX }}
                        className="absolute top-2 right-2 text-white bg-gray-100 bg-opacity-70 transition-colors rounded-sm w-6 h-6 items-center justify-center text-xs hidden group-hover:flex"
                        title="Delete"
                    >
                        <BinIcon className="stroke-red" />
                    </button>
                )}
                {thumbnailLoadFailed || !thumbnail ? (
                    <BrokenThumbnailIcon className="w-2/3 h-2/3" />
                ) : (
                    <img
                        src={thumbnail}
                        alt="thumbnail"
                        className="w-full h-full rounded object-contain aspect-square"
                        onError={(e) => {
                            setThumbnailLoadFailed(true);
                        }}
                    />
                )}
            </div>

            <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-2 items-center min-w-0 relative">
                    <p
                        className={`h-5 w-5 bg-gray-90 rounded-md text-xs ${isActive ? 'text-white' : 'text-gray-50'} text-center`}
                    >
                        {index}
                    </p>
                    <div className="relative group/title max-w-[120px]">
                        <p className={`text-xs truncate ${isActive ? 'text-white' : 'text-gray-50'}`}>{title}</p>
                        <div
                            style={{ wordBreak: 'break-word' }}
                            className="absolute z-10 top-6 bg-gray-100 text-white text-xs px-2 py-1 rounded shadow-lg opacity-0 group-hover/title:opacity-100 transition delay-200 pointer-events-none"
                        >
                            {title}
                        </div>
                    </div>
                </div>
                <p className="text-xs text-gray-110">{size}</p>
            </div>
        </div>
    );
};
